// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".buttons_93be {\n  display: inline-grid;\n  grid-gap: 0.625rem;\n  grid-auto-flow: column;\n  align-items: center;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/Buttons.scss","Buttons.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;ACCJ","file":"Buttons.scss","sourcesContent":[".buttons {\n    display: inline-grid;\n    grid-gap: 0.625rem;\n    grid-auto-flow: column;\n    align-items: center;\n}\n",".buttons {\n  display: inline-grid;\n  grid-gap: 0.625rem;\n  grid-auto-flow: column;\n  align-items: center;\n}"]}]);
// Exports
exports.locals = {
	"buttons": "buttons_93be"
};
module.exports = exports;
